import React from 'react';

import styled from 'styled-components';

import { getRandomInt } from 'constants/helper';

import EmojiPopupSelect from 'uiToolkit/EmojiPopupSelect';

const Wrapper = styled.div`
  padding-left: 18px;
`;

const OneOnOneEmojiPreview = ({ question }) => (
  <Wrapper>
    <EmojiPopupSelect editable options={question.answerOptions} resetVar={getRandomInt(1000)} />{' '}
  </Wrapper>
);

export default OneOnOneEmojiPreview;
